
// **************************************************
//
// RESIZE
//
// **************************************************
export const resize = (state, payload)=> {
  state.windowWidth = payload.width
  state.windowHeight = payload.height
}

export const setCountry = (state, payload)=> {
  state.country = payload
  state.isChina = payload === 'CN'
}

export const audioPlayable = (state, payload)=> {
  state.audio.playable = payload
}

export const audioBufferable = (state, payload)=> {
  state.audio.bufferable = payload
}


// WEBPACK FOOTER //
// ./src/store/browser/mutations.js